var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.222,
    height: 18.783,
    viewBox: "0 0 16.222 18.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy-content",
    transform: "translate(-38.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content-copy",
    transform: "translate(38.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4090",
    "data-name": "Path 4090",
    d: "M50.2,0H39.958A1.713,1.713,0,0,0,38.25,1.708V13.661h1.708V1.708H50.2Zm2.561,3.415H43.373a1.713,1.713,0,0,0-1.708,1.708V17.076a1.713,1.713,0,0,0,1.708,1.708h9.392a1.713,1.713,0,0,0,1.708-1.708V5.123A1.713,1.713,0,0,0,52.764,3.415Zm0,13.661H43.373V5.123h9.392Z",
    transform: "translate(-38.25)",
    fill: "#74b1ee"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLinkIcon);
export default __webpack_public_path__ + "static/media/copy_link_icon.7919cdaa4186ad08797ec0855e9dde7c.svg";
export { ForwardRef as ReactComponent };